export const findUserAgency = (agencies, dealer, agencyCode) => {
  return agencies.find((agency) => agency.dealerId === dealer && agency.code === agencyCode);
};
